import { useEffect, useRef, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormIndicadores } from "../abm/actividades/FormIndicadores";
import { useAbm } from "../../services";

/**
 * Contenedor único para alta/edición de indicadores.
 *
 * Se hidrata con una sola petición: datos actuales y todos los catálogos
 * necesarios para editar los indicadores de la actividad.
 */
export const ModalIndicadoresActividad = ({
  showState = [false, () => {}],
  params = {},
  selectedItem,
  loadDetails
}) => {
  const [show, setShow] = showState;
  const [data, setData] = useState({});
  const [itemData, setItemData] = useState();
  const formRef = useRef();
  const service = useAbm({entity: "actividades"});

  useEffect(() => {
    if (!show) {
      return;
    }

    let active = true;

    const loadData = async () => {
      try {
        const bootstrap = await service.getOne(params?.id, "actividades/indicadores/bootstrap");

        if (active) {
          setItemData(bootstrap?.actividad);
          setData(bootstrap?.catalogos || {});
        }
      } catch (error) {
        console.error("Error cargando formulario de indicadores", error);
      }
    };

    loadData();

    return () => {
      active = false;
      setItemData(undefined);
    };
  }, [show, service]);

  const handleCancel = () => {
    setShow(false);
  };

  const handleConfirm = async (formData) => {
    await service.update(
      {
        ...formData,
        id: params?.id
      },
      params?.id,
      "actividades/indicadores"
    );

    await loadDetails(selectedItem?.id || params?.id);
    setShow(false);
  };

  return (
    <Dialog open={show} onClose={handleCancel} keepMounted={false} maxWidth="lg" fullWidth>
      <DialogTitle>
        {params?.estado === "PENDIENTE" ? "Cargar datos" : "Editar datos"}
      </DialogTitle>
      <DialogContent>
        <FormIndicadores
          ref={formRef}
          item={itemData}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          data={data}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="success" onClick={event => formRef.current?.submit(event)}>
          Guardar
        </Button>
        <Button variant="outlined" color="error" onClick={handleCancel}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
